module.exports = __webpack_public_path__ + "components/country-flag/static/iq-bc6d6fa058e768b85b990b217c21dfba.svg";